import { Typography } from 'antd';
import styled from 'styled-components';
import { colors } from 'styles/colors';

export type TextAlignType = 'left' | 'center' | 'right';

export const SectionWrapper = styled.section`
  padding: 24px;
  max-width: 100vw;
`;

export const BodySection = styled.section`
  margin-bottom: 40px;
`;

export interface HeadingProps {
  align?: TextAlignType;
  size?: number;
}

export const MainHeading = styled(Typography.Title).attrs({ level: 2 })<HeadingProps>`
  &.ant-typography {
    font-size: ${({ size }) => `${size ? size : 26}px`};
    font-weight: 600;
    color: ${colors.primaryDark};
    margin-bottom: 20px;
    text-align: ${({ align }) => align && align};
  }
`;

export const Heading = styled(Typography.Title).attrs({ level: 3 })`
  &.ant-typography {
    font-size: 18px;
    font-weight: 600;
    color: ${colors.primaryDark};
    margin-bottom: 20px;
  }
`;

export const Subheading = styled(Typography.Title).attrs({ level: 4 })`
  &.ant-typography {
    font-size: 16px;
    font-weight: 600;
    color: ${colors.primaryDark};
    margin-bottom: 20px;
  }
`;

export const ParagraphLine = styled(Typography.Text)`
  &.ant-typography {
    display: block;
    color: ${colors.darkGray};
  }
`;

export const Paragraph = styled(Typography.Paragraph)<{
  align?: TextAlignType;
}>`
  &.ant-typography {
    color: ${colors.darkGray};
    line-height: 1.8;
    margin-bottom: 20px;
    text-align: ${({ align }) => align && align};
  }
`;

export const List = styled(Paragraph).attrs({ as: 'ul' })``;

export const GreyList = styled(Paragraph).attrs({ as: 'ul' })`
  color: ${colors.darkGray};
`;

export const CenteredLine = styled.span`
  display: block !important;
  text-align: center;
  line-height: 1.8;
`;

export const CenteredText = styled(CenteredLine)<{ minDesktop: boolean }>`
  max-width: ${({ minDesktop }) => minDesktop && '70%'};
  margin: 0 auto;
`;

export const BodyParagraph = styled(Typography.Paragraph)`
  &.ant-typography {
    color: ${colors.darkGray};
    line-height: 1.8;
  }
`;

export const BodyParagraphLine = styled(Typography.Text)`
  &.ant-typography {
    display: block;
    color: ${colors.darkGray};
  }
`;
